import React from "react";

import "../styles/Loader.css";

function Loader() { 
  return <div className="Loader">
    <p className="Loader-text">Loading, please wait...</p>
  </div>;
}

export default Loader;
